<ng-container *ngIf="form">
  <fl-form-single
    (flSubmit)="onSubmit()"
    [form]="form"
    *ngIf="form.display_type === 'single'"
  ></fl-form-single>

  <fl-form-wizard
    (flBack)="onBack($event)"
    (flNext)="onNext($event)"
    (flSubmit)="onSubmit($event)"
    [form]="form"
    [signatureRequest]="signatureRequest"
    [vehicle]="vehicle"
    *ngIf="form.display_type === 'wizard'"
  ></fl-form-wizard>

  <div class="underlying-document" *ngIf="documentDownloadType">
    <p>By filling out this form you are executing the underlying document:</p>

    <!-- Case for all previews / workflow tasks -->
    <div
      *ngIf="documentDownloadType === DocumentDownloadType.ModalDocumentPreview"
      class="clickable-container document-card"
      (click)="openDocumentPreview()"
    >
      <ng-container *ngTemplateOutlet="documentLinkContent"></ng-container>
    </div>

    <!-- Case for signature/data request RTDs -->
    <a
      *ngIf="documentDownloadType === DocumentDownloadType.NonModalRtd"
      [href]="documentPreviewLink(form)"
      class="clickable-container document-card"
      target="_blank"
    >
      <ng-container *ngTemplateOutlet="documentLinkContent"></ng-container>
    </a>
  </div>
</ng-container>

<ng-template #documentLinkContent>
  <div class="document-thumbnail-container">
    <span inlineSVG="/assets/file-icon--pdf.svg?ver=noa"></span>
  </div>

  <div class="document-info" *ngIf="!form.rtd">
    <p class="document-title">{{ form.document.title }}</p>
    <span class="document-details">{{ form.document.page_count }} pages</span>
  </div>

  <div class="document-info" *ngIf="form.rtd">
    <p class="document-title">{{ form.title }}</p>
  </div>

  <span class="document-view" inlineSVG="/assets/icons/search.svg"></span>
</ng-template>
